import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '../../../environments/environment';
import { Process, ProcessBase, ProcessSearch } from '../../models/engineering/process';
import { ProcessType } from '../../models/engineering/process-type';

@Injectable({
  providedIn: 'root',
})
export class ProcessProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/processes';
  private readonly processTypeUrl = environment.proxyUrls.itemApi + '/api/v1/process-types';

  public getProcessById(processId: string): Observable<ApiResponse<Process>> {
    return this.httpClient.get<ApiResponse<Process>>(`${this.baseUrl}/${processId}`);
  }

  public insertProcess(process: ProcessBase): Observable<ApiResponse<Process>> {
    return this.httpClient.post<ApiResponse<Process>>(`${this.baseUrl}`, process);
  }

  public updateProcess(process: Process): Observable<ApiResponse<Process>> {
    return this.httpClient.put<ApiResponse<Process>>(`${this.baseUrl}/${process.processId}`, process);
  }

  public searchProcesses(processSearch: ProcessSearch): Observable<ApiResponse<Process[]>> {
    return this.httpClient.post<ApiResponse<Process[]>>(`${this.baseUrl}/search`, processSearch);
  }

  public getProcessTypes(): Observable<ApiResponse<ProcessType[]>> {
    return this.httpClient.get<ApiResponse<ProcessType[]>>(`${this.processTypeUrl}`);
  }

  public getProcessByType(processType: string): Observable<ApiResponse<ProcessType>> {
    return this.httpClient.get<ApiResponse<ProcessType>>(`${this.baseUrl}/type/${processType}`);
  }
}
